import {
  Box,
  Button, Center,
  Flex,
  Heading,
  Spacer, Spinner,
  Text, useToast,
} from "@chakra-ui/react";
import React from "react";
import {IoDocumentTextOutline} from "react-icons/io5";
import {useQuery} from "react-query";
import {useNavigate} from "react-router-dom";

import {getActiveTest} from "../Api";
import {errorToast} from "../helper/ToastHelper";
import {useFont} from "../hooks/FontProvider";
import {useTheme} from "../hooks/ThemeProvider";
import {Paths, SkillType} from "../model/Constants";
import {TestIdResponseDto} from "../model/Dto";
import {publicKeys} from "../QueryKeys";
import {extractData} from "../Utils";

type TestCardProps = {
  name: string;
  description: string;
  skillType: SkillType;
  autoStart?: boolean;
  compact?: boolean;
  isDemo?: boolean;
  disabled?: boolean;
};

const TestCard = (props: TestCardProps) => {
  const theme = useTheme().theme;
  const font = useFont().font;
  const navigate = useNavigate();
  const toast = useToast();

  const isDemo = props.isDemo || false;

  const testQuery = useQuery(publicKeys.testByType(props.skillType), () =>
    { return getActiveTest(props.skillType, isDemo).then(extractData); });

  function handleResponse (response: TestIdResponseDto) {
    if (response.publicId && response.token) {
      navigate(Paths.TESTS_PUBLIC_ID.replace(
          ":publicId",
          response.publicId
      ).replace(
          ":candidateToken",
          response.token
      ));
    } else {
      errorToast(toast, "No se encontró una prueba asociada");
    }
  }

  if (!testQuery.data) {
    return (
        <Center height="200px">
          <Spinner />
        </Center>
    );
  }  else if (testQuery?.data?.publicId ===null || testQuery?.data?.token ===null){
      return (<></>);
  } else {
    if (props.autoStart) {
      handleResponse(testQuery.data)
    }

    if (props.compact) {
      return (
        <Button
          aria-label="Next"
          onClick={() => handleResponse(testQuery?.data)}
          colorScheme={theme.COLOR_SCHEME}
          width={font.iconButtonWidth}
          height={font.iconButtonHeight}
          disabled={props.disabled || (testQuery?.data?.publicId ===null || testQuery?.data?.token ===null)}
          _disabled={{
            cursor: 'default',
            opacity: '0.4',
          }}
        fontWeight={font.weight}
        fontSize={font.buttonText}
          whiteSpace='break-spaces'
        >{props.name}</Button>
      );
    } else {
      return (
        <Flex
          marginTop="2"
          marginBottom="2"
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          align="center"
          width="2xs"
          padding={5}
          bgColor={theme.BG}
          _dark={{ bgColor: "gray.800" }}
        >
          <Box>
            <IoDocumentTextOutline color={theme.SPECIAL_ACCENT} fontSize={36}/>
            <Button variant='link' color={theme.TEXT_ACCENT}
                    _dark={{ color: "white" }}
                    onClick={() => handleResponse(testQuery.data)}
                    disabled={props.disabled || (testQuery.data.publicId ===null || testQuery.data.token ===null)}
                    _disabled={{
                      cursor: 'default',
                      opacity: '0.4',
                    }}
            >
              <Heading as="h3" size={font.midHeading} paddingY={4} whiteSpace="pre-wrap">
                { testQuery.data.name ? testQuery.data.name : props.name}
              </Heading>
            </Button>
            <Text fontSize={font.p}>
              { testQuery.data.subtitle ? testQuery.data.subtitle : props.description}
            </Text>
          </Box>
          <Spacer/>
          <Box>
          </Box>
        </Flex>
      );

    }
  }
};

export default TestCard;
